/* eslint-disable camelcase */
/**
 * 神策数据上报
 * @see https://shimo.im/docs/KlkKVeVGYNszvEqd
 * @see https://manual.sensorsdata.cn/sa/latest/tech_sdk_client_web_use-7545346.html
 */
import { isPC } from '@geekbang/time.sdk'
import state from '@/store/state'

class SensorsReport {
  /**
   * 初始化
   */
  async init () {
    if (!window.sensors) return

    const report_source = isPC() ? 'Web' : 'H5'
    const is_login = Boolean(state.loginUser)
    const uid = state.loginUser && state.loginUser.uid ? String(state.loginUser.uid) : ''

    // 注册公共属性
    sensors.registerPage({
      is_login,
      uid,
      report_source
    })
  }
}

export default new SensorsReport()
